import { render, staticRenderFns } from "./InputTable.vue?vue&type=template&id=4a56423e&scoped=true"
import script from "./InputTable.vue?vue&type=script&lang=js"
export * from "./InputTable.vue?vue&type=script&lang=js"
import style0 from "./InputTable.vue?vue&type=style&index=0&id=4a56423e&prod&lang=scss&scoped=true"
import style1 from "./InputTable.vue?vue&type=style&index=1&id=4a56423e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a56423e",
  null
  
)

export default component.exports